// bundle related reducers
import { combineReducers } from "redux";
import { reducer as workspaceContent } from "./WorkspaceContent";

export default combineReducers({
  workspaceContent,
});
